import { render, staticRenderFns } from "./marginComponent.vue?vue&type=template&id=39113fee&scoped=true&"
import script from "./marginComponent.vue?vue&type=script&lang=js&"
export * from "./marginComponent.vue?vue&type=script&lang=js&"
import style0 from "./marginComponent.vue?vue&type=style&index=0&id=39113fee&prod&lang=less&scoped=true&"
import style1 from "./marginComponent.vue?vue&type=style&index=1&id=39113fee&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39113fee",
  null
  
)

export default component.exports